/* tslint:disable */
/* eslint-disable */

import React, { CSSProperties, SVGAttributes, FunctionComponent } from 'react';
import { getIconColor } from './helper';

interface Props extends Omit<SVGAttributes<SVGElement>, 'color'> {
  size?: number;
  color?: string | string[];
}

const DEFAULT_STYLE: CSSProperties = {
  display: 'block',
};

const IconHuiyuanka1: FunctionComponent<Props> = ({ size, color, style: _style, ...rest }) => {
  const style = _style ? { ...DEFAULT_STYLE, ..._style } : DEFAULT_STYLE;

  return (
    <svg viewBox="0 0 1024 1024" width={size + 'px'} height={size + 'px'} style={style} {...rest}>
      <path
        d="M986.752 85.333333H37.248C18.602667 85.333333 0 99.157333 0 117.589333v741.546667c0 18.432 18.602667 36.864 37.248 36.864h949.504c18.645333 0 37.248-18.432 37.248-36.864V117.589333c0-18.432-18.602667-32.256-37.248-32.256z m-37.205333 741.546667H74.453333V338.730667h879.744V826.88h-4.693333z m0-557.312H74.453333V154.453333h879.744v115.2h-4.693333z"
        fill={getIconColor(color, 0, '#333333')}
      />
      <path
        d="M615.552 534.186667l-52.138667 153.728-52.437333-153.728h-39.04L540.458667 725.333333h45.610666l68.821334-191.146666zM676.693333 534.186667V725.333333h36.906667v-191.146666zM812.970667 534.186667h-63.872V725.333333h37.12v-59.264h26.752c45.653333 0 73.472-26.197333 73.472-65.792s-27.861333-66.090667-73.472-66.090666z m0 97.493333h-26.752v-63.104h26.752c22.698667 0 35.797333 11.52 35.797333 31.701333 0 19.925333-13.098667 31.402667-35.797333 31.402667z"
        fill={getIconColor(color, 1, '#333333')}
      />
    </svg>
  );
};

IconHuiyuanka1.defaultProps = {
  size: 18,
};

export default IconHuiyuanka1;
